<template>
    <div class="content">
        <div class="content-head" v-if="showQuery">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="调款状态">
                    <el-select v-model="params.Transfer_Status" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in Transfer_Statusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核状态">
                    <el-select v-model="params.Transfer_AuditStatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in Transfer_AuditStatusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工程名称">
                    <el-input autocomplete="on" name="project_name" v-model="params.project_name" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="分支机构" v-if="isFiltration">
                    <el-input autocomplete="on" name="Transfer_SourceRegion" v-model="params.Transfer_SourceRegion" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="ERP订单号">
                    <el-input autocomplete="on" name="keyword" v-model="params.keyword" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="客户名称" v-if="isFiltration">
                    <el-input autocomplete="on" name="CustomerName" v-model="params.CustomerName" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="调款记录编号">
                    <el-input autocomplete="on" name="Transfer_SN" v-model="params.Transfer_SN" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="申请人" v-if="isFiltration">
                    <el-input autocomplete="on" name="AdderName" v-model="params.AdderName" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="录入时间" v-if="isFiltration">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getOrdersDistributetTransfer(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title" v-if="showQuery">
                调款列表
                <span>
                    <span>
                        <el-button type="primary" style="margin-right: 10px" @click="getTransferfunds()">新增</el-button>
                    </span>
                    <el-dropdown trigger="click">
                        <el-button>
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getOrdersDistributetTransferExport()">导出查询信息</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <el-table :data="tableData" border :height="maxheight" style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn" :row-class-name="tableRowClassName" @row-click="handleRowClick">
                <!-- <el-table-column prop="Transfer_ID" label="ID" width="80" align="center" fixed="left" /> -->
                <el-table-column prop="Transfer_SN" label="调款记录编号" show-overflow-tooltip width="150" align="center" fixed="left"></el-table-column>
                <el-table-column prop="Transfer_SourceERPSN" label="调出订单号" show-overflow-tooltip width="100" align="center" fixed="left"></el-table-column>
                <el-table-column prop="Transfer_SourceRegion" label="调出办事处" show-overflow-tooltip width="120" align="center"></el-table-column>
                <el-table-column prop="Transfer_SourceProjectName" label="调出工程名称" show-overflow-tooltip width="180" align="center"></el-table-column>
                <el-table-column prop="Transfer_SourceCustomerName" show-overflow-tooltip width="220" label="调出客户名称" align="center"></el-table-column>
                <el-table-column prop="Transfer_TargetERPSN" show-overflow-tooltip width="100" label="调入订单号" align="center"></el-table-column>
                <el-table-column prop="Transfer_TargetRegion" show-overflow-tooltip width="120" label="调入办事处" align="center"></el-table-column>
                <el-table-column prop="Transfer_TargetProjectName" show-overflow-tooltip width="180" label="调入工程名称" align="center"></el-table-column>
                <el-table-column prop="Transfer_TargetCustomerName" show-overflow-tooltip width="220" label="调入客户名称" align="center"></el-table-column>
                <el-table-column prop="Transfer_Amount" show-overflow-tooltip width="100" label="调款金额" align="center">
                    <template slot-scope="scope">￥ {{ scope.row.Transfer_Amount }}</template> 
                </el-table-column>
                <el-table-column prop="Transfer_AddTime" show-overflow-tooltip width="100" label="录入日期" align="center"></el-table-column>
                <el-table-column prop="Transfer_StatusName" show-overflow-tooltip width="80" label="调款状态" align="center"></el-table-column>
                <el-table-column prop="Transfer_AuditStatusName" show-overflow-tooltip width="80" label="审核状态" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Transfer_AuditStatusName == '待审核' ? 'danger' : 'success'">{{ scope.row.Transfer_AuditStatusName }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Transfer_AdderName" show-overflow-tooltip width="80" label="申请人" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="100" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleOpen(scope.row)">查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <!-- -------新增在线调款弹窗------ -->
        <AddPaymentDialog :visible.sync="showAddPaymentDialog" @success="handleAddSuccess" />
        
        <!-- -------在线调款详情------ -->
        <el-dialog title="在线调款详情" :visible.sync="isDialog" width="1200px" :before-close="handleClose" :close-on-click-modal="false" append-to-body>
            <div class="hw-content" v-loading="loading">
                <el-collapse v-model="activeNames">
                    <el-collapse-item title="调款订单信息" name="1">
                        <template slot="title">
                            <div>调款订单信息</div>
                        </template>
                        <div style="display: flex; justify-content: space-between">
                            <div style="width: 500px">
                                <el-input type="textarea" :rows="2" placeholder="取消原因" v-model="orders_close_note" v-if="isnote"></el-input>
                            </div>
                            <div>
                                <el-button v-if="isnote" @click="isnote = false">取消</el-button>
                                <el-button type="primary" v-if="isnote" @click="getCancelOrdersDistributetTransfer()">保存</el-button>
                                <el-button type="primary" v-if="!isnote && result.IsCancel" @click="isnote = true">取消</el-button>
                            </div>
                        </div>
                        <div style="display: flex; height: 30px; align-items: center; text-align: center; font-size: 14px; color: #222222">
                            <h4 style="flex: 1">调出订单</h4>
                            <h4 style="flex: 1">调入订单</h4>
                        </div>
                        <div style="display: flex">
                            <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                                <el-descriptions-item label="调出订单号">
                                    <div class="descriptions-item-content-rows">
                                        {{ result.Detail.Transfer_SourceERPSN }}
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label="调出办事处">
                                    <div class="descriptions-item-content-rows">
                                        {{ result.Detail.Transfer_SourceRegion }}
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label="业务员">
                                    <div>
                                        {{ result.Detail.Transfer_SourceSaleMan }}
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label="业务员编号">
                                    <div>
                                        {{ result.Detail.Transfer_SourceSaleManCode }}
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label="订单客户">
                                    <el-tooltip class="item" effect="dark" :content="result.Detail.Transfer_SourceCustomerName" placement="top">
                                        <div class="ellipsis descriptions-item-content-rows">
                                            {{ result.Detail.Transfer_SourceCustomerName }}
                                        </div>
                                    </el-tooltip>
                                </el-descriptions-item>
                                <el-descriptions-item label="客户编号">
                                    <div>
                                        {{ result.Detail.Transfer_SourceCustomerCode }}
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label="订单日期">
                                    <div>
                                        {{ result.Detail.Transfer_SourceOrderDate }}
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label="订单金额">
                                    <div>￥{{ result.Detail.Transfer_SourceOrderAmount }}</div>
                                </el-descriptions-item>
                                <el-descriptions-item label="工程名称">
                                    <div>{{ result.Detail.Transfer_SourceProjectName }}</div>
                                </el-descriptions-item>
                            </el-descriptions>

                            <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                                <el-descriptions-item label="调入订单号">
                                    <div class="descriptions-item-content-rows">
                                        {{ result.Detail.Transfer_TargetERPSN }}
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label="调入办事处">
                                    <div class="descriptions-item-content-rows">
                                        {{ result.Detail.Transfer_TargetRegion }}
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label="业务员">
                                    <div>{{ result.Detail.Transfer_TargetSaleMan }}</div>
                                </el-descriptions-item>
                                <el-descriptions-item label="业务员编号">
                                    <div>{{ result.Detail.Transfer_TargetSaleManCode }}</div>
                                </el-descriptions-item>
                                <el-descriptions-item label="订单客户">
                                    <el-tooltip class="item" effect="dark" :content="result.Detail.Transfer_TargetCustomerName" placement="top">
                                        <div class="ellipsis descriptions-item-content-rows">
                                            {{ result.Detail.Transfer_TargetCustomerName }}
                                        </div>
                                    </el-tooltip>
                                </el-descriptions-item>
                                <el-descriptions-item label="客户编号">
                                    <div>{{ result.Detail.Transfer_TargetCustomerCode }}</div>
                                </el-descriptions-item>
                                <el-descriptions-item label="订单日期">
                                    <div>{{ result.Detail.Transfer_TargetOrderDate }}</div>
                                </el-descriptions-item>
                                <el-descriptions-item label="订单金额">
                                    <div>￥{{ result.Detail.Transfer_TargetOrderAmount }}</div>
                                </el-descriptions-item>
                                <el-descriptions-item label="工程名称">
                                    <div>{{ result.Detail.Transfer_TargetProjectName }}</div>
                                </el-descriptions-item>
                            </el-descriptions>
                        </div>
                    </el-collapse-item>

                    <el-collapse-item title="调款信息" name="2">
                        <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                            <el-descriptions-item label="调款记录编号">
                                <div class="rows">{{ result.Detail.Transfer_SN }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="调款金额">
                                <div class="rows">￥{{ result.Detail.Transfer_Amount }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="调款状态">{{ result.Transfer_StatusName }}</el-descriptions-item>
                            <el-descriptions-item label="审核状态">
                                <span :style="result.Transfer_AuditStatusName == '待审核' ? 'color: red ' : 'color: #13ce66'">{{ result.Transfer_AuditStatusName }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="申请人">{{ result.Detail.Transfer_AdderName }}</el-descriptions-item>
                            <el-descriptions-item label="申请时间">{{ result.Detail.Transfer_AddTime | formatDate }}</el-descriptions-item>
                        </el-descriptions>
                    </el-collapse-item>

                    <el-collapse-item title="凭证信息" name="3">
                        <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                            <el-descriptions-item label="凭证类型">
                                <div class="rows">{{ result.Detail.Transfer_ReceiptType }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="汇入银行">
                                <div class="rows">{{ result.Detail.Transfer_BandName }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="汇款单位">{{ result.Detail.Transfer_Code }}</el-descriptions-item>
                            <el-descriptions-item label="汇款金额">￥{{ result.Detail.Transfer_TotalAmount }}</el-descriptions-item>
                            <el-descriptions-item label="分款日期">{{ result.Detail.Transfer_PayDate | formatDate }}</el-descriptions-item>
                            <el-descriptions-item label="分款ID">{{ result.Detail.Transfer_ERPOBJID }}</el-descriptions-item>
                            <el-descriptions-item label="混合付款ID">{{ result.Detail.Transfer_MaxID }}</el-descriptions-item>
                        </el-descriptions>
                    </el-collapse-item>

                    <el-collapse-item title="附件信息" name="4">
                        <el-table :data="result.Attachment" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" :row-class-name="tableRowClassName" @row-click="handleRowClick">
                            <el-table-column prop="Credit_Control_ReturnMoney_UserName" label="序号" align="center" width="200">
                                <template slot-scope="scope">
                                    {{ scope.$index + 1 }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Attachment_Source" label="附件文件" show-overflow-tooltip align="center">
                                <template slot-scope="scope">
                                    <span class="operation-bar-block-a" @click="downFile(scope.row.Attachment_Path)">
                                        {{ scope.row.Attachment_Source }}
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>
                    <el-collapse-item title="审核附件信息" name="5">
                        <el-table :data="result.AuditAttachment" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" :row-class-name="tableRowClassName" @row-click="handleRowClick">
                            <el-table-column prop="Credit_Control_ReturnMoney_UserName" label="序号" align="center" width="200">
                                <template slot-scope="scope">
                                    {{ scope.$index + 1 }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Credit_Control_ReturnMoney" label="附件文件" show-overflow-tooltip align="center">
                                <template slot-scope="scope">
                                    <span class="operation-bar-block-a" @click="downFile(scope.row.Attachment_Path)">
                                        {{ scope.row.Attachment_Source }}
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>

                    <el-collapse-item title="调款日志" name="6">
                        <el-table :data="result.Logs" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" :row-class-name="tableRowClassName" @row-click="handleRowClick">
                            <el-table-column prop="Credit_Control_ReturnMoney_UserName" label="序号" align="center" width="100">
                                <template slot-scope="scope">
                                    {{ scope.$index + 1 }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Credit_Control_ReturnMoney" label="时间" show-overflow-tooltip align="center" width="140">
                                <template slot-scope="scope">
                                    {{ scope.row.Log_AddTime | formatDates }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Log_Action" label="类型" align="center" width="120"></el-table-column>
                            <el-table-column prop="Log_User" label="操作人" show-overflow-tooltip align="center" width="120"></el-table-column>
                            <el-table-column prop="Log_Remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="handleClose()">关闭</el-button>
            </span>
        </el-dialog>


    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import { myMixin } from '@/utils/mixin.js';
import { cloneDeep, debounce } from 'lodash';
import { downloadFile, toLowerCaseKeys } from '@/utils/utils.js';
import Hwupload from '@/components/Hwupload/indexMany';
import AddPaymentDialog from './addPayment.vue';
export default {
    name: 'onlinePayment',
    mixins: [myMixin],
    components: {
        Pagination,
        AddPaymentDialog
    },
    props: {
        showQuery: {
            type: Boolean,
            default: true
        },
        projectName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isDialog: false,
            loading: false,
            loadingBtn: false,
            Record_loading: false,
            isnote: false,
            showAddPaymentDialog: false,
            orders_close_note: '',
            params: {
                date_start: '',
                date_end: '',
                Transfer_Status: 0,
                Transfer_AuditStatus: 0,
                Transfer_SourceRegion: '',
                keyword: '',
                project_name: this.showQuery?'':this.projectName,
                CustomerName: '',
                Transfer_SN: '',
                AdderName: ''
            },
            result: {
                Detail: {
                    Transfer_AddTime: '',
                    Transfer_AdderID: 54,
                    Transfer_AdderName: '',
                    Transfer_Amount: 10,
                    Transfer_AuditNote: '',
                    Transfer_AuditReason: '',
                    Transfer_AuditStatus: 0,
                    Transfer_BandName: '',
                    Transfer_CloseAttachment: '',
                    Transfer_Code: '',
                    Transfer_ERPOBJID: '',
                    Transfer_ID: 14,
                    Transfer_MaxID: '',
                    Transfer_OfficeID: 191,
                    Transfer_PayDate: '',
                    Transfer_ReceiptType: '',
                    Transfer_SN: '',
                    Transfer_SourceCustomerCode: '',
                    Transfer_SourceCustomerName: '',
                    Transfer_SourceERPSN: '',
                    Transfer_SourceOrderAmount: 0,
                    Transfer_SourceOrderDate: '',
                    Transfer_SourceProjectName: '',
                    Transfer_SourceRegion: '',
                    Transfer_SourceSaleMan: '',
                    Transfer_SourceSaleManCode: '',
                    Transfer_Status: 0,
                    Transfer_SyncNote: '',
                    Transfer_TargetCustomerCode: '',
                    Transfer_TargetCustomerName: '',
                    Transfer_TargetERPSN: '',
                    Transfer_TargetOrderAmount: 0,
                    Transfer_TargetOrderDate: '',
                    Transfer_TargetProjectName: '',
                    Transfer_TargetRegion: '',
                    Transfer_TargetSaleMan: '',
                    Transfer_TargetSaleManCode: '',
                    Transfer_TotalAmount: 0
                },
                Attachment: [],
                AuditAttachment: null,
                Logs: [],
                IsCancel: true,
                Transfer_StatusName: '',
                Transfer_AuditStatusName: ''
            },
            timer: [],
            tableData: [],
            activeNames: ['1', '2', '3', '4', '5', '6'],
            Transfer_Statusopt: [
                { value: 0, label: '全部' },
                { value: 1, label: '已申请' },
                { value: 2, label: '同步成功' },
                { value: 3, label: '已取消' },
                { value: -1, label: '同步失败' },
                { value: -2, label: '同步中' }
            ],
            Transfer_AuditStatusopt: [
                { value: 0, label: '全部' },
                { value: 1, label: '待审核' },
                { value: 2, label: '已审核' },
                { value: 3, label: '审核不通过' }
            ]
        };
    },
    mounted() {
        this.onRefresh();
    },
    methods: {
        /*
    重置查询
    */
        onRefresh() {
            this.params = {
                date_start: '',
                date_end: '',
                Transfer_Status: 0,
                Transfer_AuditStatus: 0,
                Transfer_SourceRegion: '',
                keyword: '',
                project_name: this.showQuery?'':this.projectName,
                CustomerName: '',
                Transfer_SN: '',
                AdderName: ''
            };
            this.getOrdersDistributetTransfer(true);
        },
        /*
    列表查询
    */
        getOrdersDistributetTransfer(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getOrdersDistributetTransfer(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        /*
      列表导出
    */
        getOrdersDistributetTransferExport() {
            this.$newsApi.getOrdersDistributetTransferExport(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },

        filteropt() {
            let params = cloneDeep(this.params);
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getOrdersDistributetTransfer();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getOrdersDistributetTransfer();
        },
        /*
    查询详情数据
    */
        getOrdersDistributetTransferByID(id) {
            this.loading = true;
            this.$newsApi
                .getOrdersDistributetTransferByID({ id })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.result = res.data.data;
                    }
                })
                .finally(() => (this.loading = false));
        },
        /*
        在线条款取消
        */
        getCancelOrdersDistributetTransfer() {
            const id = this.result.Detail.Transfer_ID;
            this.$newsApi.getCancelOrdersDistributetTransfer({ json: JSON.stringify({ orders_close_note: this.orders_close_note }), id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.isnote = false;
                    this.orders_close_note = '';
                    this.$message({
                        message: res.data.Resultinfo || '操作成功',
                        type: 'success',
                        duration: 2000, // 设置提示的显示时间，默认是3000ms
                        onClose: () => {
                            // 这里是提示关闭后的回调函数
                            this.getOrdersDistributetTransferByID(id);
                        }
                    });
                }
            });
        },
        handleOpen(result) {
            this.isnote = false;
            this.orders_close_note = '';
            this.isDialog = true;
            this.getOrdersDistributetTransferByID(result.Transfer_ID);
        },
        handleClose() {
            this.isDialog = false;
        },
        /*
        打开在线调款
        */
        getTransferfunds() {
            this.showAddPaymentDialog = true;
        },
        /*
        处理新增成功事件
        */
        handleAddSuccess() {
            this.showAddPaymentDialog = false;
            this.getOrdersDistributetTransfer(true);
        }
    }
};
</script>
<style scoped lang="scss">
/* #f5f7fa */
/deep/ .custom-label {
    text-align: right !important;
    width: 170px;
    color: #333333;
    background: #f5f7fa !important;
}

.rows {
    width: 389px;
}
.row-content {
    width: 200px;
}
.descriptions-item-content-rows {
    width: 150px;
}
.hw-content {
    padding: 0px 20px;
}
.ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 150px;
    }
}
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>
